import { atom, atomWithStorage } from '@exodus/headless-ui';
import configAtom from './config.js';
export const fromAssetNameAtom = atomWithStorage('exchange.fromAssetName');
export const fromAssetNameWithConfigAtom = atom((get) => get(fromAssetNameAtom) || get(configAtom).defaultFromAsset || 'bitcoin');
